import React, { useEffect, useState } from "react";

import API from "../../../services/api";
import socket from "../../../services/socket";

import DeliveryHeader from "../../../components/delivery/DeliveryHeader/DeliveryHeader";
import OnlineToggle from "../../../components/delivery/OnlineToggle/OnlineToggle";
import DashboardCards from "../../../components/delivery/DashboardCards/DashboardCards";
import WaitingForOrders from "../../../components/delivery/WaitingForOrders/WaitingForOrders";
import DeliveryBottomNav from "../../../components/delivery/DeliveryBottomNav/DeliveryBottomNav";
import LiveOrderRequest from "../../../components/delivery/LiveOrderRequest/LiveOrderRequest";

import "./DeliveryHome.css";

function DeliveryHome() {

    const [liveOrder, setLiveOrder] = useState(null);

    const [dashboard, setDashboard] = useState({

        work: {

            online: false,

        },

        earnings: {

            today: 0,

            total: 0,

        },

        statistics: {

            totalDeliveries: 0,

            rating: 5,

        },

        distance: 0,

    });

    // =====================================================
    // Fetch Dashboard
    // =====================================================

    const fetchDashboard = async () => {

        try {

            const [

                dashboardRes,

                earningsRes,

            ] = await Promise.all([

                API.get("/delivery/dashboard"),

                API.get("/delivery/earnings/dashboard"),

            ]);

            if (

                dashboardRes.data.success &&

                earningsRes.data.success

            ) {

                const dashboardData =
                    dashboardRes.data.dashboard;

                const earningData =
                    earningsRes.data.dashboard;

                setDashboard({

                    work: dashboardData.work,

                    earnings: {

                        today:
                            earningData.todayEarnings || 0,

                        total:
                            earningData.totalEarnings || 0,

                    },

                    statistics: {

    todayOrders:
        earningData.todayOrders,

    totalOrders:
        earningData.totalOrders,

    rating:
        dashboardData.statistics?.rating || 5

},



                    distance:
                        earningData.totalDistance || 0,

                });

            }

        }

        catch (error) {

            console.log(error);

        }

    };

    // =====================================================
    // Initial Load
    // =====================================================

    useEffect(() => {

        fetchDashboard();

    }, []);

    // =====================================================
    // Accept Order
    // =====================================================

    const handleAccept = async (orderId) => {

        try {

            await API.put(

                `/delivery/orders/${orderId}/accept`

            );

            setLiveOrder(null);

            fetchDashboard();

        }

        catch (error) {

            console.log(error);

        }

    };

    // =====================================================
    // Reject Order
    // =====================================================

    const handleReject = async (orderId) => {

        try {

            await API.put(

                `/delivery/orders/${orderId}/reject`

            );

            setLiveOrder(null);

            fetchDashboard();

        }

        catch (error) {

            console.log(error);

        }

    };

    // =====================================================
    // Socket
    // =====================================================

    useEffect(() => {

       const user = JSON.parse(localStorage.getItem("user"));

console.log("========== DELIVERY LOGIN ==========");
console.log("Local User:", user);
console.log("Sending ID:", user?.id);
console.log("===================================");

if (user?.id) {
    socket.emit("register-delivery", user.id);
}
socket.on("connect", () => {
    console.log("🟢 Connected:", socket.id);
});

socket.on("disconnect", () => {
    console.log("🔴 Disconnected");
});
        socket.on(

            "new-delivery-request",

            (order) => {

                console.log("🔥 New Order");

                console.log(order);

                setLiveOrder(order);

                fetchDashboard();

            }

        );

        socket.on(

            "order-accepted",

            () => {

                fetchDashboard();

            }

        );

        socket.on(

            "order-delivered",

            () => {

                fetchDashboard();

            }

        );

        socket.on(

            "dashboard-refresh",

            () => {

                fetchDashboard();

            }

        );

        return () => {

            socket.off("new-delivery-request");

            socket.off("order-accepted");

            socket.off("order-delivered");

            socket.off("dashboard-refresh");

        };

    }, []);

    // =====================================================
    // Auto Refresh Every 15 Seconds
    // =====================================================

    useEffect(() => {

        const interval = setInterval(() => {

            fetchDashboard();

        }, 15000);

        return () => clearInterval(interval);

    }, []);

    return (

        <div className="delivery-home">

            <DeliveryHeader />

            <div className="delivery-home-content">

                <OnlineToggle

                    online={dashboard.work.online}

                    refresh={fetchDashboard}

                />

                <DashboardCards

                    dashboard={dashboard}

                />

               {
    liveOrder ? (

        <LiveOrderRequest
            order={liveOrder}
            onAccept={handleAccept}
            onReject={handleReject}
        />

    ) : (

        <WaitingForOrders />

    )
}

            </div>

            <DeliveryBottomNav />

        </div>

    );

}

export default DeliveryHome;